// extracted by mini-css-extract-plugin
module.exports =  {"button":"_2787e5dfdf--button--xh3YU"};